"use strict";
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IbhIcnPartsResponseDtoIcnProcedureEnum = exports.IbhLifetimeInputFieldConfigDtoUnitEnum = exports.IbhMaterialLightResponseDtoProcedureEnum = exports.IbhWidenDtoTypeEnum = exports.IbhMaterialResponseDtoProcedureEnum = exports.IbhShape = exports.IbhOppositeMaterialIds = exports.IbhTechnicalEnvironment = exports.IbhSpatialTypeOfMovements = exports.IbhTemporalTypeOfMovement = exports.IbhUnitSystem = exports.IbhProductionMethods = exports.IbhPriceType = exports.IbhFileType = exports.IbhGeoFileType = exports.IbhProcedure = exports.IbhIcnProcedure = void 0;
/** Procedures for materials */
var IbhIcnProcedure;
(function (IbhIcnProcedure) {
    IbhIcnProcedure["SLS"] = "SLS";
    IbhIcnProcedure["FDM"] = "FDM";
    IbhIcnProcedure["IM"] = "IM";
    IbhIcnProcedure["DLP"] = "DLP";
    IbhIcnProcedure["CNC"] = "CNC";
    IbhIcnProcedure["CNCEXPRESS"] = "CNC-EXPRESS";
    IbhIcnProcedure["COATING"] = "COATING";
    IbhIcnProcedure["WOUND"] = "WOUND";
})(IbhIcnProcedure || (exports.IbhIcnProcedure = IbhIcnProcedure = {}));
var IbhProcedure;
(function (IbhProcedure) {
    IbhProcedure["SLS"] = "SLS";
    IbhProcedure["FDM"] = "FDM";
    IbhProcedure["IM"] = "IM";
    IbhProcedure["DLP"] = "DLP";
    IbhProcedure["CNC"] = "CNC";
    IbhProcedure["COATING"] = "COATING";
    IbhProcedure["WOUND"] = "WOUND";
})(IbhProcedure || (exports.IbhProcedure = IbhProcedure = {}));
var IbhGeoFileType;
(function (IbhGeoFileType) {
    IbhGeoFileType["Stp"] = "stp";
    IbhGeoFileType["Stl"] = "stl";
})(IbhGeoFileType || (exports.IbhGeoFileType = IbhGeoFileType = {}));
var IbhFileType;
(function (IbhFileType) {
    IbhFileType["Stp"] = "stp";
    IbhFileType["Stl"] = "stl";
    IbhFileType["Drawing"] = "drawing";
    IbhFileType["Report"] = "report";
    IbhFileType["Zip"] = "zip";
})(IbhFileType || (exports.IbhFileType = IbhFileType = {}));
/** The type of the price */
var IbhPriceType;
(function (IbhPriceType) {
    IbhPriceType["Binding"] = "binding";
    IbhPriceType["NonBinding"] = "non-binding";
    IbhPriceType["Onrequest"] = "onrequest";
})(IbhPriceType || (exports.IbhPriceType = IbhPriceType = {}));
/** Form type of the article */
var IbhProductionMethods;
(function (IbhProductionMethods) {
    IbhProductionMethods["MOLDINJECTION"] = "MOLD-INJECTION";
    IbhProductionMethods["THREEDIMENSIONALPRINT"] = "THREE-DIMENSIONAL-PRINT";
    IbhProductionMethods["SEMIFINISHED"] = "SEMI-FINISHED";
    IbhProductionMethods["MECHANICALREPROCESSING"] = "MECHANICAL-REPROCESSING";
    IbhProductionMethods["FASTLINE"] = "FAST-LINE";
    IbhProductionMethods["WOUND"] = "WOUND";
})(IbhProductionMethods || (exports.IbhProductionMethods = IbhProductionMethods = {}));
/**
 * Unit system in which is defined the article
 *
 * - If unitSystem is `metric`, dimensions are defined in millimeters `mm`
 * - If unitSystem is `imperial`, dimensions are defined in inches `in`
 */
var IbhUnitSystem;
(function (IbhUnitSystem) {
    IbhUnitSystem["Metric"] = "metric";
    IbhUnitSystem["Imperial"] = "imperial";
})(IbhUnitSystem || (exports.IbhUnitSystem = IbhUnitSystem = {}));
var IbhTemporalTypeOfMovement;
(function (IbhTemporalTypeOfMovement) {
    IbhTemporalTypeOfMovement["Simultaneous"] = "simultaneous";
    IbhTemporalTypeOfMovement["Sequential"] = "sequential";
})(IbhTemporalTypeOfMovement || (exports.IbhTemporalTypeOfMovement = IbhTemporalTypeOfMovement = {}));
var IbhSpatialTypeOfMovements;
(function (IbhSpatialTypeOfMovements) {
    IbhSpatialTypeOfMovements["Rotation"] = "rotation";
    IbhSpatialTypeOfMovements["Linear"] = "linear";
    IbhSpatialTypeOfMovements["Pivoting"] = "pivoting";
    IbhSpatialTypeOfMovements["LinearAndRotation"] = "linear and rotation";
    IbhSpatialTypeOfMovements["LinearAndPivoting"] = "linear and pivoting";
})(IbhSpatialTypeOfMovements || (exports.IbhSpatialTypeOfMovements = IbhSpatialTypeOfMovements = {}));
var IbhTechnicalEnvironment;
(function (IbhTechnicalEnvironment) {
    IbhTechnicalEnvironment["Dry"] = "dry";
    IbhTechnicalEnvironment["UnderWater"] = "underWater";
})(IbhTechnicalEnvironment || (exports.IbhTechnicalEnvironment = IbhTechnicalEnvironment = {}));
var IbhOppositeMaterialIds;
(function (IbhOppositeMaterialIds) {
    IbhOppositeMaterialIds["Value1"] = "1";
    IbhOppositeMaterialIds["Value2"] = "2";
    IbhOppositeMaterialIds["Value6"] = "6";
    IbhOppositeMaterialIds["Value8"] = "8";
    IbhOppositeMaterialIds["Value9"] = "9";
    IbhOppositeMaterialIds["Value3"] = "3";
    IbhOppositeMaterialIds["Value4"] = "4";
})(IbhOppositeMaterialIds || (exports.IbhOppositeMaterialIds = IbhOppositeMaterialIds = {}));
/** Bearing shape name */
var IbhShape;
(function (IbhShape) {
    IbhShape["S"] = "S";
    IbhShape["F"] = "F";
    IbhShape["T"] = "T";
    IbhShape["PR"] = "PR";
    IbhShape["EC"] = "EC";
    IbhShape["C"] = "C";
    IbhShape["FSG"] = "FSG";
    IbhShape["FL"] = "FL";
    IbhShape["VFL"] = "VFL";
    IbhShape["Y"] = "Y";
    IbhShape["YK"] = "YK";
    IbhShape["TE"] = "TE";
    IbhShape["D"] = "D";
    IbhShape["VF"] = "VF";
    IbhShape["K"] = "K";
    IbhShape["VS"] = "VS";
})(IbhShape || (exports.IbhShape = IbhShape = {}));
/** The exact procedure used for that material */
var IbhMaterialResponseDtoProcedureEnum;
(function (IbhMaterialResponseDtoProcedureEnum) {
    IbhMaterialResponseDtoProcedureEnum["SLS"] = "SLS";
    IbhMaterialResponseDtoProcedureEnum["FDM"] = "FDM";
    IbhMaterialResponseDtoProcedureEnum["IM"] = "IM";
    IbhMaterialResponseDtoProcedureEnum["DLP"] = "DLP";
    IbhMaterialResponseDtoProcedureEnum["CNC"] = "CNC";
    IbhMaterialResponseDtoProcedureEnum["COATING"] = "COATING";
    IbhMaterialResponseDtoProcedureEnum["WOUND"] = "WOUND";
})(IbhMaterialResponseDtoProcedureEnum || (exports.IbhMaterialResponseDtoProcedureEnum = IbhMaterialResponseDtoProcedureEnum = {}));
/** Media type, 'image' or 'drawing' */
var IbhWidenDtoTypeEnum;
(function (IbhWidenDtoTypeEnum) {
    IbhWidenDtoTypeEnum["Image"] = "image";
    IbhWidenDtoTypeEnum["Drawing"] = "drawing";
})(IbhWidenDtoTypeEnum || (exports.IbhWidenDtoTypeEnum = IbhWidenDtoTypeEnum = {}));
/** The exact procedure used for that material */
var IbhMaterialLightResponseDtoProcedureEnum;
(function (IbhMaterialLightResponseDtoProcedureEnum) {
    IbhMaterialLightResponseDtoProcedureEnum["SLS"] = "SLS";
    IbhMaterialLightResponseDtoProcedureEnum["FDM"] = "FDM";
    IbhMaterialLightResponseDtoProcedureEnum["IM"] = "IM";
    IbhMaterialLightResponseDtoProcedureEnum["DLP"] = "DLP";
    IbhMaterialLightResponseDtoProcedureEnum["CNC"] = "CNC";
    IbhMaterialLightResponseDtoProcedureEnum["COATING"] = "COATING";
    IbhMaterialLightResponseDtoProcedureEnum["WOUND"] = "WOUND";
})(IbhMaterialLightResponseDtoProcedureEnum || (exports.IbhMaterialLightResponseDtoProcedureEnum = IbhMaterialLightResponseDtoProcedureEnum = {}));
var IbhLifetimeInputFieldConfigDtoUnitEnum;
(function (IbhLifetimeInputFieldConfigDtoUnitEnum) {
    IbhLifetimeInputFieldConfigDtoUnitEnum["Angle"] = "angle";
    IbhLifetimeInputFieldConfigDtoUnitEnum["AreaMilli"] = "areaMilli";
    IbhLifetimeInputFieldConfigDtoUnitEnum["DistanceMilli"] = "distanceMilli";
    IbhLifetimeInputFieldConfigDtoUnitEnum["Force"] = "force";
    IbhLifetimeInputFieldConfigDtoUnitEnum["PressureMega"] = "pressureMega";
    IbhLifetimeInputFieldConfigDtoUnitEnum["RotationalVelocity"] = "rotationalVelocity";
    IbhLifetimeInputFieldConfigDtoUnitEnum["Temperature"] = "temperature";
    IbhLifetimeInputFieldConfigDtoUnitEnum["Time"] = "time";
    IbhLifetimeInputFieldConfigDtoUnitEnum["TimeMinute"] = "timeMinute";
    IbhLifetimeInputFieldConfigDtoUnitEnum["Velocity"] = "velocity";
    IbhLifetimeInputFieldConfigDtoUnitEnum["WearPerHour"] = "wearPerHour";
})(IbhLifetimeInputFieldConfigDtoUnitEnum || (exports.IbhLifetimeInputFieldConfigDtoUnitEnum = IbhLifetimeInputFieldConfigDtoUnitEnum = {}));
/** Requested procedures */
var IbhIcnPartsResponseDtoIcnProcedureEnum;
(function (IbhIcnPartsResponseDtoIcnProcedureEnum) {
    IbhIcnPartsResponseDtoIcnProcedureEnum["SLS"] = "SLS";
    IbhIcnPartsResponseDtoIcnProcedureEnum["FDM"] = "FDM";
    IbhIcnPartsResponseDtoIcnProcedureEnum["IM"] = "IM";
    IbhIcnPartsResponseDtoIcnProcedureEnum["DLP"] = "DLP";
    IbhIcnPartsResponseDtoIcnProcedureEnum["CNC"] = "CNC";
    IbhIcnPartsResponseDtoIcnProcedureEnum["CNCEXPRESS"] = "CNC-EXPRESS";
    IbhIcnPartsResponseDtoIcnProcedureEnum["COATING"] = "COATING";
    IbhIcnPartsResponseDtoIcnProcedureEnum["WOUND"] = "WOUND";
})(IbhIcnPartsResponseDtoIcnProcedureEnum || (exports.IbhIcnPartsResponseDtoIcnProcedureEnum = IbhIcnPartsResponseDtoIcnProcedureEnum = {}));
//# sourceMappingURL=data-contracts.js.map